module.exports = __webpack_public_path__ + "static/media/holiday.726da459.svg";